module.exports = __webpack_public_path__ + "static/media/biometric-5.7189f15c.svg";